import React, { Component } from 'react';
import UserContext from '../tools/contextLib';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import { Input, Table, Button, Form, FormGroup, FormText } from 'reactstrap';
import { GoCheck } from 'react-icons/go';
import moment from 'moment';

export class DistroLists extends Component {
    static displayName = DistroLists.name;

    constructor(props) {
        super(props);

        this.state = {
            browser: `${browserName}${browserVersion}`,
            ip: "",
            userInfo: [],
            activeDeptPK: [],
            distroOptions: [],
            loading: true,
            tableData: [],
            isPrimary: null,
            fullUserList: [],
            addSuccess: false,
            deleteSuccess: false
        }
        this.getData();
    }

    async getData() {
        const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
        const data = await response.json();
        this.setState({
            ip: data.ip
        }, () => { this.getUserInfo(); })//The only reason I'm putting this in a callback instead of letting it run async to getData() is because I need to be sure both execute before recordComingHere()
    }

    async getUserInfo() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        const response = await fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            returnable: data,
            username: data.username,
        }, () => { this.recordComingHere(); this.getUserDeptPK(data.level); });
    }

    async recordComingHere() {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            pagePK: "1041",
            department: this.state.returnable.level,
            userPCID: this.state.returnable.pcid,
            ip: this.state.ip,
            browser: this.state.browser,
            userID: this.state.returnable.username
        }
        const response = await fetch('logging', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
    }

    async getUserDeptPK(dept) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            userLevel: dept
        }
        const response = await fetch('GetUserDeptPK', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            activeDeptPK: data
        }, () => { this.getListOptions(data.deptpk); this.getFormUserOptions(data.deptpk); })
    }

    async getListOptions(pk) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            deptpk: pk,
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetValidDistroLists', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            distroOptions: data
        })
    }

    async getFormUserOptions(pk) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            deptpk: pk,
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetDistroFormOptions', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            fullUserList: data
        })
    }

    componentDidMount() {

    }

    async selectDistroList(target) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        this.setState({
            activeList: target
        })
        let toSend = {
            deptpk: this.state.activeDeptPK.deptpk,
            selectList: target,
            userLevel: this.state.returnable.level
        }
        const response = await fetch('GetDistroListData', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            tableData: data.dataout,
            isPrimary: data.isowner,
            loading: false
        })
    }

    async newUser(e) {
        e.preventDefault();
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        console.log("submit form: " + e.target.formUser.value);
        let toSend = {
            deptpk: this.state.activeDeptPK.deptpk,
            listpk: this.state.activeList,
            pcid: e.target.formUser.value,
            userLevel: this.state.returnable.level
        }
        const response = await fetch('AddDistroListUser', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            addSuccess: data
        }, () => {
            this.selectDistroList(this.state.activeList);
            setTimeout(() => { this.setState({addSuccess: false}) }, 4000)
        }) 
    }

    async deleteUser(pk) {
        let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let toSend = {
            deptpk: this.state.activeDeptPK.deptpk,
            userpk: pk,
            userLevel: this.state.returnable.level
        }
        const response = await fetch('DeleteDistroListUser', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        });
        const data = await response.json();
        localStorage.setItem("lastFetch", moment());
        this.setState({
            deleteSuccess: data
        }, () => {
            this.selectDistroList(this.state.activeList);
            setTimeout(() => { this.setState({ deleteSuccess: false }) }, 4000)
        }) 
    }

    showData() {
        return (<div>
            <div className="inlineCustom">
                {this.state.isPrimary && <Form className="d-flex" onSubmit={this.newUser.bind(this)} id="newUser">
                    <Input type="select" name="formUser" id="formUser" defaultValue="DEFAULT">
                        <option value="DEFAULT" disabled>Select...</option>
                        {this.state.fullUserList.filter(full => !this.state.tableData.filter(sub => sub.pcid === full.pcid).length).map(item => (
                            <option value={item.pcid}>{item.name} ({item.pcid})</option>
                        ))}
                    </Input>
                    <Button type="submit" outline color="success">Add</Button>{this.state.addSuccess && <GoCheck />}
                </Form>}
            </div>
            <div>
                <Table striped>
                    <thead>
                        <tr>
                            <th>PCID</th>
                            <th>Name</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.tableData.map(item => (
                            <tr>
                                <td>{item.pcid}</td>
                                <td>{item.username}</td>
                                {this.state.isPrimary && < td > <Button outline color="danger" onClick={() => this.deleteUser(item.pk)}>Delete</Button></td>}
                            </tr>
                        )) }
                    </tbody>
                </Table>
            </div>
        </div>);
    }

    render() {
        if (this.state.activeDeptPK == '3' || this.state.activeDeptPK == '4') {//DistroLists needs to be available to all non-student departments. Non-traditional AuthN/AuthZ is necessary.
            this.props.passNewPage(-1);
        }
        if (this.props.justSwitch === true) {
            this.props.passNewPage(1);
        }
        let displayData = <div></div>
        if (!this.state.loading) { displayData = this.showData() }
        return (<div>
            <div className="inlineCustom">
                <Input type="select" defaultValue="DEFAULT" name="distroMain" id="distroMain" onChange={(e) => this.selectDistroList(e.target.value) }>
                    <option value="DEFAULT" disabled>Select...</option>
                    {this.state.distroOptions.map(item => (
                        <option value={item.listpk}>{item.listname}</option>
                    ))}
                    {this.state.distroOptions.length == 0 &&
                            <option value="NULL" disabled>Your department does not have any distribution lists assigned to it.</option>}
                </Input>
            </div>
            <br />
            <br />
            <br />
            {displayData}
        </div>);
    }
}